import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import PaymentsTable from "../components/customerorderform/PaymentsTable";
import SalesTable from "../components/customerorderform/SalesTable";
import TotalCalculations from "../components/customerorderform/TotalCalculations";
import ControlMenu from "../components/reusable/ControlMenu";
import DateInputField from "../components/reusable/DateInputField";
import DropdownInput from "../components/reusable/DropdownInput";
import TextInputField from "../components/reusable/TextInputField";
import APIContext from "../context/APIContext";

let useStyles = makeStyles({
	input__num: {
		"& input[type=number]": {
			"-moz-appearance": "textfield",
		},
		"& input[type=number]::-webkit-outer-spin-button": {
			"-webkit-appearance": "none",
			margin: 0,
		},
		"& input[type=number]::-webkit-inner-spin-button": {
			"-webkit-appearance": "none",
			margin: 0,
		},
	},
});

const CustomerOrderForm = (props) => {
	// default values for the input fields in the form
	// LocId: "",
	// 	TranPrtPhone: "",
	// 	mobile2: "",
	// 	TranPrtName: "",
	// 	TranPrtCivilId: "",
	// 	TranPrtNation: "",
	// 	address: "",
	// 	TranPrtArea: "",
	// 	orderRefNo: "",
	// 	orderNo: "",
	// 	TranDate: dayjs("2014-08-18T21:11:54"),
	// 	orderType: "",
	// 	TranSManId: "",
	// 	TranGoldRate: "",
	// 	TranRemark1: "",
	// 	mobile1: "",
	let defaultValues = {
		location: "",
		orderNo: "",
		orderRefNo: "",
		mobile1: "",
		mobile2: "",
		civilId: "",
		date: dayjs("2014-08-18T21:11:54"),
		orderType: "",
		salesman: "",
		goldRate: "",
		customer: "",
		address: "",
		area: "",
		remarks: "",
	};
	const [formValues, setFormValues] = React.useState(defaultValues);

	let classes = useStyles();

	//  onChange function for the form values
	const handleChange = (prop) => (event) => {
		setFormValues({ ...formValues, [prop]: event.target.value });
	};

	// onChange function for the date field
	const handleChangeDate = (newValue) => {
		setFormValues({ ...formValues, date: newValue });
	};

	let { locations, salesman, orderType } = useContext(APIContext);

	// default values for the input fields in the form
	let defaultCalc = {
		discount: 0.0,
		netAmount: 0.0,
		giftWrapCharge: 0.0,
		advanceReceived: 0.0,
		totalAmount: 0.0,
	};
	const [formCalc, setFormCalc] = React.useState(defaultCalc);

	let defaultSalesRecord = {
		serial: "",
		itemCode: "",
		itemName: "",
		purity: "",
		mcType: "",
		qty: "",
		grossWgt: "",
		stoneWgt: "",
		netWgt: "",
		pureWgt: "",
		rateGm: "",
		totalAmt: "",
	};

	const [salesRecord, setSalesRecord] = React.useState(defaultSalesRecord);
	let [gridValues, setgridValues] = useState([]);

	let [receivedPayments, setReceivedPayments] = useState([]);

	useEffect(() => {
		//console.log(formValues, formCalc);
	}, [formValues, formCalc]);

	return (
		<>
			<Paper elevation={0} sx={{ padding: ".2em", m: 1 }}>
				<Stack spacing={1}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							mt: 0.2,
						}}
					>
						<Typography variant="h6">Customer Order Form</Typography>
						<Typography variant="h6">New</Typography>
					</div>

					<Box>
						<Grid container spacing={1} sx={{ mb: 1 }}>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<DropdownInput
									label="Location"
									onChange={handleChange("location")}
									value={formValues.location}
									options={locations}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									value={formValues.orderNo}
									label="Order No"
									onChange={handleChange("orderNo")}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Order Ref No"
									onChange={handleChange("orderRefNo")}
									value={formValues.orderRefNo}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Mobile"
									onChange={handleChange("mobile1")}
									value={formValues.mobile1}
									classname={classes.input__num}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Mobile"
									onChange={handleChange("mobile2")}
									value={formValues.mobile2}
									classname={classes.input__num}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Civil ID"
									onChange={handleChange("civilId")}
									value={formValues.civilId}
									classname={classes.input__num}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<DateInputField
									label="Date"
									onChange={handleChangeDate}
									value={formValues.date}
								/>
							</Grid>
						</Grid>
						<Grid container spacing={1} sx={{ mb: 0.3 }}>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<DropdownInput
									label="Order Type"
									onChange={handleChange("orderType")}
									value={formValues.orderType}
									options={orderType}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<DropdownInput
									label="Salesman"
									onChange={handleChange("salesman")}
									value={formValues.salesman}
									options={salesman}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									value={formValues.goldRate}
									label="Gold Rate (24k)"
									onChange={handleChange("goldRate")}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Customer"
									onChange={handleChange("customer")}
									value={formValues.customer}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Address"
									onChange={handleChange("address")}
									value={formValues.address}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Area"
									onChange={handleChange("area")}
									value={formValues.area}
								/>
							</Grid>
							<Grid item sm={6} lg={1.71428571} md={3}>
								<TextInputField
									label="Remarks"
									onChange={handleChange("remarks")}
									value={formValues.remarks}
								/>
							</Grid>
						</Grid>
					</Box>

					<SalesTable
						setgridValues={setgridValues}
						salesRecord={salesRecord}
						setSalesRecord={setSalesRecord}
						defaultSalesRecord={defaultSalesRecord}
						gridValues={gridValues}
						locations={locations}
					/>

					<Box>
						<Grid container spacing={3}>
							<Grid item xs={12} md={8}>
								<PaymentsTable
									setReceivedPayments={setReceivedPayments}
									defaultSalesRecord={defaultSalesRecord}
									receivedPayments={receivedPayments}
									locations={locations}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<TotalCalculations
									formCalc={formCalc}
									setFormCalc={setFormCalc}
								/>
							</Grid>
						</Grid>
					</Box>
				</Stack>
			</Paper>
			<ControlMenu data={{ formValues, gridValues, receivedPayments }} />
		</>
	);
};

export default CustomerOrderForm;
